<template>
  <div class="msgtypeLocation">
    <div :id="'mymap' + index" class="mymap">
      <p>{{ title }}</p>
    </div>
  </div>
</template>

<script>
import MapLoader from '@/components/map/AMap.js';
export default {
  name: '',
  props: {
    items: {
      type: Object,
      default() {
        return {};
      },
    },
    index: {
      type: Number,
      default() {
        return '';
      },
    },
  },
  data() {
    return {
      title: '',
    };
  },
  created() {
    MapLoader().then(
      () => {
        setTimeout(() => {
          this.initMap();
        }, 0);
      },
      () => {
        this.MapLoader();
      },
    );
  },
  methods: {
    initMap() {
      const content = JSON.parse(this.items.msg_content);
      this.title = JSON.parse(this.items.msg_content).Label;
      const { LocationX } = content;
      const { LocationY } = content;
      // 创建地图实例
      const map = new window.AMap.Map(`mymap${this.index}`, {
        zoom: 15,
        resizeEnable: true,
        center: [LocationY, LocationX], // 初始化地图中心点
      });
      window.AMap.plugin(['AMap.ToolBar'], function () {});
      this.map = map;
    },
  },
};
</script>

<style scoped lang="scss">
.msgtypeLocation {
  padding: 0 12px;
  box-sizing: border-box;
  width: 258px;
  height: 136px;
  .mymap {
    width: 258px;
    height: 136px;
    border-radius: 8px;
    position: relative;
    p {
      background: rgba(48, 49, 51, 0.65);
      border-radius: 0 0 8px 8px;
      width: 100%;
      height: 32px;
      line-height: 32px;
      color: #ffffff;
      font-size: 16px;
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 9999;
      padding: 0 10px;
      box-sizing: border-box;
    }
  }
}
</style>
